var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEditMini = function SvgEditMini(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#3B7CC9",
    fillRule: "evenodd",
    d: "M3.522 9.535a.745.745 0 0 1 .007-.007L8.196 4.86l2-2a.667.667 0 0 1 .943 0l2 2c.26.26.26.683 0 .943l-6.667 6.667a.667.667 0 0 1-.471.195H4a.667.667 0 0 1-.667-.667v-2a.667.667 0 0 1 .188-.464ZM6 11.056l3.724-3.723-1.058-1.058L4.943 10l1.058 1.057Zm3.61-5.723 1.056 1.057 1.058-1.057-1.058-1.058L9.61 5.333Z",
    clipRule: "evenodd"
  })));
};
export default SvgEditMini;